import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GettingStartedSteps } from '../../../../../../enums/getting-started-steps.enum';
import { StepperContextService } from '../../../../../../services/stepper-context.service';
import { StepperAnswersService } from '../../../../../../services/stepper-answers.service';
import { AboutYouSteps } from '../../../../../../enums/about-you-steps.enum';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { StepSection } from '../../../../../../enums/step-section.enum';

export enum HomebuyingStatusOptions {
  PurchaseContract = 'I have a purchase contract',
  MakingOffers = 'Making Offers',
  PreApproval = 'I have a pre-approval',
  LookingRates = 'I’m looking at rates'
}
@Component({
  selector: 'lgv-homebuying-status',
  standalone: true,
  imports: [CommonModule,
    MatDividerModule,
    MatButtonModule
  ],
  templateUrl: './homebuying-status.component.html',
  styleUrls: ['./homebuying-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomebuyingStatusComponent {

  HomebuyingStatusOptions = HomebuyingStatusOptions
  isDialog = this.contextService.isDialog
  prepopulatedPurpose = this.contextService.purposePrepopulated
  optionSelected = this.answerService.getAnswer(GettingStartedSteps.HomebuyingStatus) ?? []

  @Output() stepChange = new EventEmitter<any>();
  @Output() sectionChange = new EventEmitter<any>();
  @Output() closeDialog = new EventEmitter<any>();

  constructor(
    public contextService: StepperContextService,
    public answerService: StepperAnswersService
  ) { }

  onAnswerSelected(ans: string) {
    const index = this.optionSelected.indexOf(ans);
    if (index === -1) {
      // Not selected yet, add it
      this.optionSelected.push(ans);
    } else {
      // Already selected, remove it
      this.optionSelected.splice(index, 1);
    }
  }

  onNext() {
    this.answerService.setAnswer(GettingStartedSteps.HomebuyingStatus, this.optionSelected)
    this.goToSection(StepSection.AboutYou, AboutYouSteps.BorrowerPersonalInfo)
  }

  onBack() {
    if (this.prepopulatedPurpose && this.isDialog) {
      this.onClose()
    } else {
      this.answerService.setAnswer(GettingStartedSteps.HomebuyingStatus, this.optionSelected)
      this.stepChange.emit(GettingStartedSteps.LoanPurpose);
    }
  }

  onClose() {
    this.answerService.clear()
    this.contextService.clear()
    this.closeDialog.emit();
  }

  goToSection(section, step) {
    this.sectionChange.emit([section, step]);
  }

  isBtnSelected(option: string) {
    return this.optionSelected.includes(option);
  }

  isNextDisabled(): boolean {
    if (this.optionSelected.length === 0) {
      return true
    }
    return false
  }
}
